import React, { Component } from "react"
import request from "superagent"
import { Formik, Field, Form } from "formik"
import buyerFields from "models/buyer"
import fieldStatus from "helpers/fieldStatus"
import * as Yup from "yup"
import submitData from "helpers/submitData"
//import Select from "components/Select"
import ReactSelect from "components/ReactSelect"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import { bindActionCreators } from "redux"
import Dropzone from "react-dropzone"
import NumberField from "components/NumberField"
import clone from "clone"
import settings from "settings"
import classNames from "classnames"
import axios from "axios"
import jsonify from "helpers/jsonify"
import _ from "lodash"
import cleanLeaveZero from "helpers/cleanLeaveZero"
import moment from "moment"
import currentUser from "helpers/currentUser"
import helpers from "helpers/helpers"
import { toast } from "react-toastify"
import pushData from "helpers/asyncSubmitData"

class BuyerModal extends Component {
	constructor(props) {
		super(props)
		this.state = {
			fields: buyerFields,
			noticeStatus: false,
			noticeDropStatus: false,
			files: [],
			sale: [],
			user: currentUser(),
			data: {
				address: "",
			},
			ref: null,
		}
		this.files = {}
	}

	componentDidMount() {
		this.getPaperwork()
	}

	getPaperwork = () => {
		this.determineDocs()
		let d = {
			buyer_id: this.props.data.buyer_id,
			sale_id: this.props.data.sale_id,
			lot_data: true,
			buyer_data: true,
		}
		let userToken = localStorage.getItem("user")
		axios
			.post(settings.ep + "/getPaperwork", d, {
				headers: { Authorization: `Bearer ${userToken}` },
			})
			.then((resp) => {
				//console.log(resp.data)
				let fields = clone(this.state.fields)
				let data = cleanLeaveZero(resp.data.buyer)
				let f = { ...fields, ...data }
				f.has_co = f.has_co == 1 ? true : false
				f.buyer_country = f.buyer_country ? f.buyer_country : "US"
				f.buyer_state = f.buyer_state ? f.buyer_state : settings.defaultState
				this.setState({
					fields: f,
					sale: resp.data.sale,
				})
			})
	}

	validation = () => {
		if (this.props.super) {
			return Yup.object().shape({})
		} else if (settings?.customValidation?.paperwork) {
			return Yup.object().shape(settings.customValidation.paperwork)
		} else {
			let shape = {
				primary_last: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				primary_first: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
				primary_age: Yup.string().required("Required"),
				primary_employer: Yup.string().required("Required"),
				primary_occupation: Yup.number().min(1, "Please choose an option from the list.").required("Required"),
				buyer_country: Yup.string().required("Required"),
				buyer_city: Yup.string().when("buyer_country", {
					is: "US",
					then: Yup.string().required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				buyer_state: Yup.string().when("buyer_country", {
					is: "US",
					then: Yup.string().required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				buyer_address: Yup.string().when("buyer_country", {
					is: "US",
					then: Yup.string().required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				buyer_zip: Yup.string().when("buyer_country", {
					is: "US",
					then: Yup.string()
						.min(5, "Must be 5 characters")
						.max(5, "Must be 5 characters")
						.required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				is_relo: Yup.number()
					.nullable(false, "Please choose an option from the list.")
					.required("Required")
					.typeError("Please choose an option from the list."),
				has_co: Yup.boolean(),
				co_first: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				co_last: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				co_occupation: Yup.number().when("has_co", {
					is: true,
					then: Yup.number()
						.min(1, "Please choose an option from the list.")
						.typeError("Please choose an option from the list.")
						.required("Required"),
					otherwise: Yup.number().nullable().notRequired(),
				}),
				co_employer: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().notRequired(),
					otherwise: Yup.string().notRequired(),
				}),
				co_age: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().required("Required"),
					otherwise: Yup.string().notRequired(),
				}),
				co_email: Yup.string().when("has_co", {
					is: true,
					then: Yup.string().email("Invalid email address").notRequired(),
					otherwise: Yup.string().notRequired(),
				}),
				primary_email: Yup.string().email("Invalid email address").required("Required"),

				first_time: Yup.number().required("Required"),
				is_moving_within: Yup.number().required("Required"),
				has_extended_fam: Yup.number().required("Required"),
				num_residents: Yup.number().required("Required"),
			}
			if (settings.enabled && settings.enabled.buyer_phone) {
				shape.buyer_phone = Yup.string()
					.min(10, "Must be a full phone number.")
					.max(10, "Must be a full phone number.")
					.required("Required")
			}
			return Yup.object().shape(shape)
		}
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	numChildren = () => {
		let ret = []
		for (let i = 1; i <= 10; i++) {
			ret.push({ value: i, label: i })
		}
		return ret
	}

	coFields = (f) => {
		if (f.values.has_co) {
			return (
				<React.Fragment>
					<li className={fieldStatus("co_first", f)}>
						<label htmlFor="co_first">
							Co-Buyer First Name
							{helpers.outputRequiredAsterix(this.validation(), "co_first", f.values)}
						</label>
						{f.errors.co_first && f.touched.co_first && (
							<div className="form__message">{f.errors.co_first}</div>
						)}
						<Field name="co_first" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("co_last", f)}>
						<label htmlFor="co_last">
							Co-Buyer Last Name{helpers.outputRequiredAsterix(this.validation(), "co_last", f.values)}
						</label>
						{f.errors.co_last && f.touched.co_last && (
							<div className="form__message">{f.errors.co_last}</div>
						)}
						<Field name="co_last" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("co_email", f)}>
						<label htmlFor="co_email">Co-Buyer Email</label>
						{f.errors.co_email && f.touched.co_email && (
							<div className="form__message">{f.errors.co_email}</div>
						)}
						<Field name="co_email" type="email" className="form__input" />
					</li>
					<li className={fieldStatus("co_occupation", f)}>
						<label htmlFor="co_occupation">
							Co-Buyer Occupation {helpers.outputRequiredAsterix(this.validation(), "co_occupation")}
						</label>
						{f.errors.co_occupation && f.touched.co_occupation && (
							<div className="form__message">{f.errors.co_occupation}</div>
						)}
						<ReactSelect
							name="co_occupation"
							options={this.props.payload.public.occupations}
							className="form__input"
							value={f.values.co_occupation}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.co_occupation}
							error={f.errors.co_occupation}
						/>
					</li>
					<li className={fieldStatus("co_employer", f)}>
						<label htmlFor="co_employer">Co-Buyer Employer</label>
						{f.errors.co_employer && f.touched.co_employer && (
							<div className="form__message">{f.errors.co_employer}</div>
						)}
						<Field name="co_employer" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("co_age", f)}>
						<label htmlFor="co_age">
							Co Age Range{helpers.outputRequiredAsterix(this.validation(), "co_age")}
						</label>
						{f.errors.co_age && f.touched.co_age && <div className="form__message">{f.errors.co_age}</div>}
						<ReactSelect
							name="co_age"
							options={[
								{
									value: "18 - 24",
									label: "18 - 24",
								},
								{
									value: "25 - 34",
									label: "25 - 34",
								},
								{
									value: "35 - 44",
									label: "35 - 44",
								},
								{
									value: "45 - 54",
									label: "45 - 54",
								},
								{
									value: "55 - 64",
									label: "55 - 64",
								},
								{
									value: "65+",
									label: "65+",
								},
							]}
							className="form__input"
							value={f.values.co_age}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.co_age}
							error={f.errors.co_age}
						/>
					</li>
				</React.Fragment>
			)
		}
	}

	onDrop = (files, data) => {
		//console.log(this.props)
		this.props.loadingStatus(true)
		this.files[data.folder] = files[0]
		const req = request.post(`${settings.ep}/inputDocument`)
		req.attach(this.files[data.folder].name, this.files[data.folder])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field(
			"attributes",
			JSON.stringify({ lot_id: this.props.data.id, sale_id: this.props.data.sale_id, data: data })
		)
		req.timeout({
			response: 35000, // Wait 5 seconds for the server to start sending,
			deadline: 60000, // but allow 1 minute for the file to finish loading.
		})
		req.end((err, response) => {
			console.log(err, response)
			//return
			let resp = response.body

			if (err && err.timeout) {
				console.log("Timeout")
				toast.error("File taking too large or taking too long to upload.  Please reduce file size.")
			} else if (err) {
				console.log(err)
				toast.error(resp.message)
			}
			if (resp.status == 200) {
				this.getPaperwork()
			}
			this.props.loadingStatus(false)
		})
	}

	determineDocs = () => {
		let docs = _.find(this.props.payload.public.properties, { id: this.props.data.property })
		if (docs && docs.assigned_docs && docs.assigned_docs.length > 0) {
			let fields = _.filter(docs.assigned_docs, (r) => {
				if (docs.assigned_docs.includes(r)) {
					return r
				}
			})
			let ret = _.map(fields, (v) => {
				let details = _.find(this.props.payload.public.options.docs, { id: v })
				if (details) {
					details.status = false
					return details
				}
			})
			this.setState({ files: ret })
		}
	}

	compileDocs = (f) => {
		//console.table(this.state.sale.documents)
		//console.log('%c' + `Compiling`, 'background: #222; color: #bada55')
		//console.log(this.state)

		return _.map(this.state.files, (details) => {
			let pending = false
			let rejected = false
			let accepted = false
			let rejectedMsg = ""
			//let findPending = _.find(this.state.sale.documents, { type: details.dbName, upload_date: false })
			let findPending = _.find(this.state.sale.documents, (v) => {
				if (v.type == details.dbName && v.status == "pending") {
					return true
				}
			})
			let findAccepted = _.find(this.state.sale.documents, (v) => {
				if (v.type == details.dbName && v.status == "accepted") {
					return true
				}
			})
			let findRejected = _.find(this.state.sale.documents, (v) => {
				if (v.type == details.dbName && v.status == "rejected") {
					return true
				}
			})
			if (findPending) {
				pending = true
			}
			if (findAccepted) {
				accepted = true
			}
			if (findRejected) {
				rejected = true
				rejectedMsg = (
					<div className="form__rejection">
						<p>Rejected: {findRejected.reason}</p>
					</div>
				)
			}
			let template
			if (details.template) {
				template = (
					<a href={details.template} class="text-xs mx-2" target="_blank">
						Download Template
					</a>
				)
			}
			return (
				<li className={fieldStatus(details.folder, f)} key={`${details.folder}`}>
					<label htmlFor={`${details.folder}`}>
						{details.name}
						{template}
					</label>
					{rejectedMsg}
					{f.errors[details.folder] && f.touched[details.folder] && (
						<div className="form__message">{f.errors[details.folder]}</div>
					)}
					<div
						className={classNames("dropzone__status", {
							active: details.status,
							pending: pending,
							rejected: rejected,
							accepted: accepted,
						})}>
						<div className="dropzone__pending">
							<i className="fad fa-lamp-desk dropzone__icon"></i>
							<p className="dropzone__text">Under Review</p>
						</div>
						<div className="dropzone__accepted">
							<i className="far fa-shield-check dropzone__icon"></i>
							<p className="dropzone__text">Accepted</p>
						</div>
					</div>
					<Dropzone
						multiple={false}
						onDrop={(files) => {
							this.onDrop(files, details)
						}}>
						{({ getRootProps, getInputProps }) => (
							<section
								className={classNames("dropzone", {
									active: details.status,
									pending: pending,
									accepted: accepted,
								})}>
								<div {...getRootProps()} className="dropbox__cont">
									<input {...getInputProps()} />
									<p className="dropzone__action">
										Drag 'n' drop file here, or click to select files
									</p>
								</div>
							</section>
						)}
					</Dropzone>
				</li>
			)
		})
	}

	addlFields = (f) => {
		let specific = _.get(settings, `addlBuyerFields.communitySpecific.${this.props.data.property}`)
		let global = _.get(settings, `addlBuyerFields.global`)
		if (specific) {
			let ret = []
			_.forEach(specific, (v) => {
				if (v.type == "dropdown") {
					ret.push(
						<li className={fieldStatus(v.id, f)} key={v.id}>
							<label htmlFor={v.id}>{v.name}</label>
							{f.errors.addl?.[v.id] && f.touched.addl?.[v.id] && (
								<div className="form__message">{f.errors.addl?.[v.id]}</div>
							)}
							<ReactSelect
								name={`addl.${v.id}`}
								options={v.options}
								className="form__input"
								value={f.values[v.id]}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched[v.id]}
								error={f.errors[v.id]}
							/>
						</li>
					)
				} else if (v.type === "text") {
					ret.push(
						<li className={fieldStatus(v.id, f)} key={v.id}>
							<label htmlFor={v.id}>{v.name}</label>
							{f.errors.addl?.[v.id] && f.touched.addl?.[v.id] && (
								<div className="form__message">{f.errors.addl?.[v.id]}</div>
							)}
							<Field name={`addl.${v.id}`} type="text" className="form__input" />
						</li>
					)
				}
			})
			return ret
		}
		if (global) {
			let ret = []
			_.forEach(global, (v) => {
				if (v.type == "dropdown") {
					ret.push(
						<li className={fieldStatus(v.id, f)} key={v.id}>
							<label htmlFor={v.id}>{v.name}</label>
							{f.errors.addl?.[v.id] && f.touched.addl?.[v.id] && (
								<div className="form__message">{f.errors.addl?.[v.id]}</div>
							)}
							<ReactSelect
								name={`addl.${v.id}`}
								options={v.options}
								className="form__input"
								value={f.values?.addl?.[v.id]}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched?.addl?.[v.id]}
								error={f.errors?.addl?.[v.id]}
							/>
						</li>
					)
				} else if (v.type === "text") {
					ret.push(
						<li className={fieldStatus(v.id, f)} key={v.id}>
							<label htmlFor={v.id}>
								{v.name}
								{v.ifApplicable && <span className="text-xs ml-2">(If Applicable)</span>}
							</label>
							{f.errors.addl?.[v.id] && f.touched.addl?.[v.id] && (
								<div className="form__message">{f.errors.addl?.[v.id]}</div>
							)}

							<Field name={`addl.${v.id}`} type="text" className="form__input" />
						</li>
					)
				}
			})
			return ret
		}
		return ""
	}

	standardFields = (f) => {
		let user = currentUser()
		let primaryFirst = () => {
			if (user.group == 1 || this.props.viewAs) {
				return <Field name="primary_first" type="text" className="form__input" />
			} else {
				return this.state.fields.primary_first
			}
		}
		let primaryLast = () => {
			if (user.group == 1 || this.props.viewAs) {
				return <Field name="primary_last" type="text" className="form__input" />
			} else {
				return this.state.fields.primary_last
			}
		}
		let info = (
			<>
				<li className={fieldStatus("primary_first", f)}>
					<label htmlFor="primary_first">
						Buyer First Name{helpers.outputRequiredAsterix(this.validation(), "primary_first")}
					</label>
					{f.errors.primary_first && f.touched.primary_first && (
						<div className="form__message">{f.errors.primary_first}</div>
					)}
					{primaryFirst()}
				</li>
				<li className={fieldStatus("primary_last", f)}>
					<label htmlFor="primary_last">
						Buyer Last Name{helpers.outputRequiredAsterix(this.validation(), "primary_last")}
					</label>
					{f.errors.primary_last && f.touched.primary_last && (
						<div className="form__message">{f.errors.primary_last}</div>
					)}
					{primaryLast()}
				</li>
			</>
		)
		let isSuper = () => {
			if (this.props.viewAs || user.group === 1) {
				return (
					<li className={fieldStatus("has_co", f)}>
						<label htmlFor="has_co">Has Co-Buyer?</label>
						{f.errors.has_co && f.touched.has_co && <div className="form__message">{f.errors.has_co}</div>}
						<Field
							name="has_co"
							type="checkbox"
							className="form__input"
							onChange={(event) => f.setFieldValue("has_co", event.target.checked)}
							checked={f.values.has_co}
						/>
					</li>
				)
			}
		}
		let states = this.props.payload.public.states
		if (f.values.buyer_country === "CA") {
			states = helpers.canadianProvinces()
		}
		let input = (
			<>
				<li className={fieldStatus("primary_email", f)}>
					<label htmlFor="primary_email">
						Buyer Email {helpers.outputRequiredAsterix(this.validation(), "primary_email")}
					</label>
					{f.errors.primary_email && f.touched.primary_email && (
						<div className="form__message">{f.errors.primary_email}</div>
					)}
					<Field name="primary_email" type="email" className="form__input" />
				</li>
				<li className={fieldStatus("primary_age", f)}>
					<label htmlFor="primary_age">
						Primary Age Range{helpers.outputRequiredAsterix(this.validation(), "primary_age")}
					</label>
					{f.errors.primary_age && f.touched.primary_age && (
						<div className="form__message">{f.errors.primary_age}</div>
					)}
					<ReactSelect
						name="primary_age"
						options={[
							{
								value: "18 - 24",
								label: "18 - 24",
							},
							{
								value: "25 - 34",
								label: "25 - 34",
							},
							{
								value: "35 - 44",
								label: "35 - 44",
							},
							{
								value: "45 - 54",
								label: "45 - 54",
							},
							{
								value: "55 - 64",
								label: "55 - 64",
							},
							{
								value: "65+",
								label: "65+",
							},
						]}
						className="form__input"
						value={f.values.primary_age}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.primary_age}
						error={f.errors.primary_age}
					/>
				</li>
				<li className={fieldStatus("primary_occupation", f)}>
					<label htmlFor="primary_occupation">
						Occupation {helpers.outputRequiredAsterix(this.validation(), "primary_occupation")}
					</label>
					{f.errors.primary_occupation && f.touched.primary_occupation && (
						<div className="form__message">{f.errors.primary_occupation}</div>
					)}
					<ReactSelect
						name="primary_occupation"
						options={this.props.payload.public.occupations}
						className="form__input"
						value={f.values.primary_occupation}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.primary_occupation}
						error={f.errors.primary_occupation}
					/>
				</li>
				<li className={fieldStatus("primary_employer", f)}>
					<label htmlFor="primary_employer">
						Primary Employer {helpers.outputRequiredAsterix(this.validation(), "primary_employer")}
					</label>
					{f.errors.primary_employer && f.touched.primary_employer && (
						<div className="form__message">{f.errors.primary_employer}</div>
					)}
					<Field name="primary_employer" type="text" className="form__input" />
				</li>
				<li className={fieldStatus("buyer_country", f)}>
					<label htmlFor="buyer_country">
						Country {helpers.outputRequiredAsterix(this.validation(), "buyer_country")}
					</label>
					{f.errors.buyer_country && f.touched.buyer_country && (
						<div className="form__message">{f.errors.buyer_country}</div>
					)}
					<ReactSelect
						name="buyer_country"
						options={this.props.payload.public.countries}
						className="form__input"
						value={f.values.buyer_country}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.buyer_country}
						error={f.errors.buyer_country}
					/>
				</li>
				<li className={fieldStatus("buyer_address", f)}>
					<label htmlFor="buyer_address">
						Mailing Address {helpers.outputRequiredAsterix(this.validation(), "buyer_address")}
						<p className="text-xs font-normal">At time of purchase</p>
					</label>
					{f.errors.buyer_address && f.touched.buyer_address && (
						<div className="form__message">{f.errors.buyer_address}</div>
					)}
					<Field name="buyer_address" type="text" className="form__input" />
				</li>
				<li className={fieldStatus("buyer_city", f)}>
					<label htmlFor="buyer_city">
						City {helpers.outputRequiredAsterix(this.validation(), "buyer_city")}
					</label>
					{f.errors.buyer_city && f.touched.buyer_city && (
						<div className="form__message">{f.errors.buyer_city}</div>
					)}
					<Field name="buyer_city" type="text" className="form__input" />
				</li>
				<li className={fieldStatus("buyer_state", f)}>
					<label htmlFor="buyer_state">
						State {helpers.outputRequiredAsterix(this.validation(), "buyer_state")}
					</label>
					{f.errors.buyer_state && f.touched.buyer_state && (
						<div className="form__message">{f.errors.buyer_state}</div>
					)}
					<ReactSelect
						name="buyer_state"
						options={states}
						className="form__input"
						value={f.values.buyer_state}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.buyer_state}
						error={f.errors.buyer_state}
					/>
				</li>
				<li className={fieldStatus("buyer_zip", f)}>
					<label htmlFor="buyer_zip">
						Current Zip {helpers.outputRequiredAsterix(this.validation(), "buyer_zip")}
					</label>
					{f.errors.buyer_zip && f.touched.buyer_zip && (
						<div className="form__message">{f.errors.buyer_zip}</div>
					)}
					<Field name="buyer_zip" type="text" className="form__input" />
				</li>
				{settings.enabled && settings.enabled.buyer_phone && (
					<li className={fieldStatus("buyer_phone", f)}>
						<label htmlFor="buyer_phone">
							Phone {helpers.outputRequiredAsterix(this.validation(), "buyer_phone")}
						</label>
						{f.errors.buyer_phone && f.touched.buyer_phone && (
							<div className="form__message">{f.errors.buyer_phone}</div>
						)}
						<NumberField
							name={`buyer_phone`}
							value={f.values.buyer_phone}
							format="+1 (###) ###-####"
							className="form__input"
							isNumericString
							onChange={(name, v) => {
								f.setFieldValue(`buyer_phone`, v)
							}}
							onBlur={() => f.setFieldTouched("buyer_phone", true)}
						/>
					</li>
				)}
				{isSuper()}
				{this.coFields(f)}
				<li className={fieldStatus("is_relo", f)}>
					<label htmlFor="is_relo">Relo {helpers.outputRequiredAsterix(this.validation(), "is_relo")}</label>
					{f.errors.is_relo && f.touched.is_relo && <div className="form__message">{f.errors.is_relo}</div>}
					<ReactSelect
						name="is_relo"
						options={[
							{
								value: 0,
								label: "No",
							},
							{
								value: 1,
								label: "Yes",
							},
						]}
						className="form__input"
						value={f.values.is_relo}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.is_relo}
						error={f.errors.is_relo}
					/>
				</li>
				<li className={fieldStatus("first_time", f)}>
					<label htmlFor="first_time">
						First Time Buyer? {helpers.outputRequiredAsterix(this.validation(), "first_time")}
					</label>
					{f.errors.first_time && f.touched.first_time && (
						<div className="form__message">{f.errors.first_time}</div>
					)}
					<ReactSelect
						name="first_time"
						options={[
							{
								value: 0,
								label: "No",
							},
							{
								value: 1,
								label: "Yes",
							},
						]}
						className="form__input"
						value={f.values.first_time}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.first_time}
						error={f.errors.first_time}
					/>
				</li>
				<li className={fieldStatus("is_moving_within", f)}>
					<label htmlFor="is_moving_within">
						Moving within Community? {helpers.outputRequiredAsterix(this.validation(), "is_moving_within")}
					</label>
					{f.errors.is_moving_within && f.touched.is_moving_within && (
						<div className="form__message">{f.errors.is_moving_within}</div>
					)}
					<ReactSelect
						name="is_moving_within"
						options={[
							{
								value: 0,
								label: "No",
							},
							{
								value: 1,
								label: "Yes",
							},
						]}
						className="form__input"
						value={f.values.is_moving_within}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.is_moving_within}
						error={f.errors.is_moving_within}
					/>
				</li>
				<li className={fieldStatus("has_extended_fam", f)}>
					<label htmlFor="has_extended_fam">
						Extended Family Living in Home?{" "}
						{helpers.outputRequiredAsterix(this.validation(), "has_extended_fam")}
					</label>
					{f.errors.has_extended_fam && f.touched.has_extended_fam && (
						<div className="form__message">{f.errors.has_extended_fam}</div>
					)}
					<ReactSelect
						name="has_extended_fam"
						options={[
							{
								value: 0,
								label: "No",
							},
							{
								value: 1,
								label: "Yes",
							},
						]}
						className="form__input"
						value={f.values.has_extended_fam}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.has_extended_fam}
						error={f.errors.has_extended_fam}
					/>
				</li>
				<li className={fieldStatus("num_residents", f)}>
					<label htmlFor="num_residents">
						Total Number of Family members/residents?{" "}
						{helpers.outputRequiredAsterix(this.validation(), "num_residents")}
					</label>
					{f.errors.num_residents && f.touched.num_residents && (
						<div className="form__message">{f.errors.num_residents}</div>
					)}
					<ReactSelect
						name="num_residents"
						options={this.numChildren()}
						className="form__input"
						value={f.values.num_residents}
						onChange={f.setFieldValue}
						onBlur={f.setFieldTouched}
						touched={f.touched.num_residents}
						error={f.errors.num_residents}
					/>
				</li>
				{this.addlFields(f)}
			</>
		)
		// Salesperson withouht buyer profile approved, or a super admin
		if ((!this.props.viewAs && !this.state.sale.buyer_profile_approved) || this.props.viewAs || user.group == 1) {
			return (
				<>
					{info}
					{input}
				</>
			)
		} else if (!this.props.viewAs && this.state.sale.buyer_profile_approved) {
			// Salesperson with profile approved, dont show them rest of the fields
			return <>{info}</>
		} else {
			return (
				<>
					{info}
					{input}
				</>
			)
		}
	}

	formLayout = (f) => {
		// check if rejected
		let rejCheck = _.find(this.state.sale.documents, (v) => {
			if (v.type == "profile" && v.status == "rejected") {
				return true
			}
		})
		let rejection = ""
		if (rejCheck) {
			rejection = (
				<div className="form__rejection">
					<p>Profile Rejected: {rejCheck.reason}</p>
				</div>
			)
		}
		let submit = <input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
		if (
			this.props.data.buyer_profile_approved &&
			this.state.user.group !== settings.groups.dev &&
			!this.state.user.viewAs
		) {
			submit = null
		}
		let approved = ""
		let profileIndex = _.findIndex(this.props.data.documents, { type: "profile" })
		if (
			profileIndex !== -1 &&
			typeof profileIndex == "number" &&
			this.props.data.documents[profileIndex].approved_date
		) {
			approved = (
				<p>
					Buyer Profile Approved:{" "}
					{moment.unix(this.props.data.documents[profileIndex].approved_date).format("MM/DD/YY")}
				</p>
			)
		}
		return (
			<div>
				<h3>
					Buyer Info: {this.props.data.address}{" "}
					<span
						className="text-xs underline ml-3 cursor-pointer text-slate-600 hover:text-slate-400 transition"
						onClick={() => this.saveProgress(f.values)}>
						<i className="fas fa-cloud-download" style={{ marginRight: 4 }} />
						Save Progress
					</span>
				</h3>
				{approved}
				{rejection}
				{/* console.log(f) */}
				<Form>
					<ul className="modalForm__list">
						{this.standardFields(f)}
						{this.compileDocs(f)}
					</ul>
					{submit}
				</Form>
			</div>
		)
	}

	saveProgress = async (values) => {
		values.action = "saveBuyerProgress"
		let resp = await pushData("mainIngest", values)
		toast.success(resp.message)
	}

	render() {
		//console.log(this.state, this.props)
		let approved = ""
		let profileIndex = _.findIndex(this.props.data.documents, { type: "profile" })
		if (
			profileIndex !== -1 &&
			typeof profileIndex == "number" &&
			this.props.data.documents[profileIndex].approved_date
		) {
			approved = (
				<p>
					Buyer Profile Approved:{" "}
					{moment.unix(this.props.data.documents[profileIndex].approved_date).format("MM/DD/YY")}
				</p>
			)
		}
		return (
			<div className="modal">
				<Formik
					initialValues={this.state.fields}
					validationSchema={this.validation}
					validateOnMount={true}
					enableReinitialize
					onSubmit={(values) => {
						//console.log(values)
						values.sale_id = this.state.sale.id
						values = jsonify(values)
						values.has_co = values.has_co ? 1 : 0
						submitData("updateBuyer", values)
							.then((data) => {
								this.props.notify(data, this.props.name)
							})
							.catch((e) => {
								this.props.notify(e, this.props.name)
							})
					}}>
					{(f) => this.formLayout(f)}
				</Formik>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		trafficSources: state.trafficSources,
		payload: state.payload,
		viewAs: state.viewAs,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuyerModal)
